import { createAction, handleActions } from 'redux-actions';
// api
import api from '../../utils/api';

const initialState = {
  completedSteps: [],
  isLoading: false,
  isStepSubmitting: false
};

// const
export const GET_COMPLETED_STEPS = 'completedSteps/GET_COMPLETED_STEPS';
export const SUBMIT_STEP = 'completedSteps/SUBMIT_STEP';
export const UPDATE_STEP = 'completedSteps/UPDATE_STEP';

// action creators
export const getModuleCompletedSteps = createAction(
  GET_COMPLETED_STEPS,
  api.moduleSteps.getModuleSteps
);
export const submitStep = createAction(SUBMIT_STEP, api.moduleSteps.submitStep);
export const updateStep = createAction(UPDATE_STEP, api.moduleSteps.updateStep);

// reducer
const reducer = handleActions(
  {
    [`${SUBMIT_STEP}_REQUEST`]: state => {
      return {
        ...state,
        isStepSubmitting: true
      };
    },
    [`${SUBMIT_STEP}_SUCCESS`]: (state, { payload: { resource } }) => {
      return {
        ...state,
        isStepSubmitting: false,
        completedSteps: [...state.completedSteps, resource]
      };
    },
    [`${SUBMIT_STEP}_ERROR`]: state => {
      return {
        ...state,
        isStepSubmitting: false
      };
    },
    [`${UPDATE_STEP}_SUCCESS`]: (state, { payload: { resource } }) => {
      const completedSteps = state.completedSteps.filter(
        ({ id }) => id !== resource.id
      );
      return {
        ...state,
        completedSteps: [...completedSteps, resource]
      };
    },
    [`${GET_COMPLETED_STEPS}_REQUEST`]: state => {
      return {
        ...state,
        isLoading: true
      };
    },
    [`${GET_COMPLETED_STEPS}_SUCCESS`]: (state, { payload }) => {
      const {
        resource: { step_progresses }
      } = payload;
      return {
        ...state,
        completedSteps: step_progresses,
        isLoading: false
      };
    },
    [`${GET_COMPLETED_STEPS}_ERROR`]: state => {
      return {
        ...state,
        isLoading: false
      };
    }
  },
  initialState
);

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/completedSteps.js